import React, { useEffect } from 'react';
import infoIconImg from 'images/info.png';
import { NotificationManager } from 'react-notifications';
import renderHTML from 'react-render-html';
import styled from 'styled-components';
import { isTerminal } from 'utils/UiHelper';

const ToggleListWrapper = styled.section`
    height: ${({ height }) => (height ? height : '40px')};
    width: auto;
    margin-bottom: 1px;
    background-color: #1c3e60;
    cursor: pointer;
    ${({ expanded }) => (expanded ? null : 'margin-bottom: 1px')};

    .info-tooltip {
        opacity: 1 !important;
        z-index: 1;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);
        text-align: left;
    }
`;
const ToolbarTitle = styled.div`
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #fff;
    padding: 10px 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    img {
        vertical-align: middle;
        margin-left: 5px;
        line-height: 20px;
    }
`;

const ToggleIcon = styled.div`
    text-align: center;
    line-height: 38px;
    font-size: 14px;
    color: #fff;
`;

const ViewToggleListToolbar = ({
    toggleHandler,
    tournamentId,
    opened,
    infoIcon,
    withoutArrow,
    height,
    title,
    titleId,
    type,
}) => {
    const onClickHandler = () => {
        if (toggleHandler) {
            toggleHandler(!isExpand(), tournamentId);
        }
    };

    const isExpand = () => {
        return opened === 'yes';
    };

    const showInfo = (text, e) => {
        NotificationManager.info('', text, 5000);
        e.stopPropagation();
        e.preventDefault();
    };

    const renderInfoIcon = () => {
        return !isTerminal() && infoIcon ? (
            <img
                src={infoIconImg}
                onClick={() => showInfo('', infoIcon)}
                height="13px"
                alt="ingo"
            />
        ) : null;
    };
    let arrow = <i className="fa fa-chevron-up" aria-hidden="true" />;

    if (type && type === 'right-arrow') {
        arrow = <i className="fa fa-angle-right" aria-hidden="true" />;
    } else {
        if (!isExpand()) {
            arrow = <i className="fa fa-chevron-down" aria-hidden="true" />;
        }
    }
    return (
        <ToggleListWrapper
            id={
                titleId ||
                title
                    .toLowerCase()
                    .split(' ')
                    .join('-')
            }
            height={height}
            expanded={true}
            onClick={onClickHandler}
        >
            <div className="row">
                <div className={!withoutArrow ? 'col-9' : 'col-10'}>
                    <ToolbarTitle>
                        {renderHTML(title)}
                        &nbsp; {renderInfoIcon()}
                    </ToolbarTitle>
                </div>

                {!withoutArrow ? (
                    <ToggleIcon className="col-1"> {arrow} </ToggleIcon>
                ) : null}
            </div>
        </ToggleListWrapper>
    );
};

export default ViewToggleListToolbar;
